export default __webpack_public_path__ + "static/media/man.db86b4ba.svg";